import CountUp from "react-countup";
import { Col, Container, Row } from "reactstrap";
import { BuildYourFuture, FindYourJob } from "../../../constants";
import { JobCounterData, JobHomeSectionData, JonHomeContent } from "../../../data/demo/JobDemo1";
import { JobHomeType } from "../../../types/HomeDemo";
import { dynamicImage, dynamicSvg, Image } from "../../../utils";
import SearchTabList from "../common/SearchTabList";

const JobHomeSection = () => {
  const renderImage = (imageData: JobHomeType) => {
    const src = imageData.type === "svg" ? dynamicSvg(imageData.image) : dynamicImage(imageData.image);
    return <Image src={src} alt={imageData.image} className={`img-fluid ${imageData.class || ""}`} />;
  };

  return (
    <div className="job-home-section">
      <Container>
        <div className="home-block-space">
          <Row className="align-items-center">
            <Col xl="7" lg="6">
              <div className="home-content">
                <h3>{BuildYourFuture}</h3>
                <h1>{FindYourJob}</h1>
                <p>{JonHomeContent}</p>
                <ul className="counter-list">
                  {JobCounterData.map((item, index) => (
                    <li className="counter-box" key={index}>
                      <div className="counter-info">
                        <h3>
                          <CountUp end={item.end} className="counter-count" delay={0} />
                          {item.suffix}
                        </h3>
                        <h4>{item.label}</h4>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </Col>
            <Col xl="5" lg="6">
              <div className="home-img">
                {JobHomeSectionData.map((item, index) => {
                  if ("meanClass" in item) {
                    return (
                      <div key={index} className={item.meanClass}>
                        {item.multipleImage.map((imgData, imgIndex) => {
                          if ("childrenClass" in imgData) {
                            return (
                              <div key={imgIndex} className={imgData.childrenClass}>
                                {imgData.childrenImage.map((childImg) => renderImage(childImg))}
                              </div>
                            );
                          }
                          return renderImage(imgData);
                        })}
                      </div>
                    );
                  }
                  return renderImage(item);
                })}
              </div>
            </Col>
          </Row>
        </div>
        <div className="property-home-tab car-home-tab job-home-tab">
          <SearchTabList basicTab={1} showTab={[1, 7, 8, 9]} scrollDown showNav />
        </div>
      </Container>
    </div>
  );
};

export default JobHomeSection;
